<template>
  <gc-dashboard-empty-state
    v-if="!priceGroups.length"
    title="No Price Groups"
    message="No price groups have been assigned to this customer."
  />
  <DxDataGrid
    v-else
    :data-source="priceGroups"
    :show-borders="true"
    :show-column-lines="true"
    :show-row-lines="true"
    :column-auto-width="true"
    :columns="columns"
    :paging="{ enabled: false }"
    :pager="{ visible: false }"
    :column-chooser="{ enabled: false }"
    :search-panel="{ visible: false }"
  />
</template>

<script>
import { DxDataGrid } from "devextreme-vue/data-grid";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import GcDashboardEmptyState from "./gc-dashboard-empty-state.vue";

export default {
  name: "GcDashboardPriceGroupsCard",
  components: { DxDataGrid, GcDashboardEmptyState },
  props: {
    priceGroups: {
      type: Array,
      required: true,
    },
  },
  computed: {
    columns() {
      return [
        {
          caption: "Price Group",
          dataField: "PriceGroupID",
          alignment: "left",
          width: ColumnWidth.Code.width,
          minWidth: ColumnWidth.Code.minWidth,
        },
        {
          caption: "Short Description",
          dataField: "ShortDescription",
        },
        {
          caption: "Start Date",
          dataField: "StartDate",
          dataType: "date",
          format: "dd MMM yyyy",
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
        },
        {
          caption: "End Date",
          dataField: "EndDate",
          dataType: "date",
          format: "dd MMM yyyy",
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
        },
      ];
    },
  },
};
</script>
